module.exports = __webpack_public_path__ + "img/list.9a4226ae.svg";